import { loadStripe } from '@stripe/stripe-js';
import { useSelector } from 'react-redux';
import i18n from 'i18n-js';

let stripePromise = null;

export const useStripePayment = () => {
  const stripeKey = useSelector(
    (state) => state.config?.settings?.core?.payment?.brokers?.STP?.public_key
  );

  if (!stripePromise && stripeKey) {
    stripePromise = loadStripe(stripeKey).catch(() => {
      stripePromise = null;
      return null;
    });
  }

  const confirmPayment = async (clientSecret, paymentMethodId) => {
    if (!stripeKey)
      return { error: { message: i18n.t('account_statement.stripe_not_initialized') } };
    try {
      const stripe = await stripePromise;
      if (!stripe)
        return { error: { message: i18n.t('account_statement.stripe_not_initialized') } };
      return stripe.confirmCardPayment(clientSecret, {
        payment_method: paymentMethodId,
        return_url: window.location.href,
      });
    } catch (err) {
      return { error: { message: err?.message || i18n.t('account_statement.stripe_error') } };
    }
  };

  return { confirmPayment };
};
